import xlsx from "node-xlsx";
//

const deepClone = (object) => JSON.parse(JSON.stringify(object));

const fileHelper = {
  readExcelFile: async (path) => {
    try {
      // Parse a file
      // [{
      //     name: 'Sheet1',
      //     data: [
      //       [Array], [Array], [Array], [], [], []
      //     ]
      // }]
      const workSheetsFromFile = await xlsx.parse(path);

      if (workSheetsFromFile) {
        // 移除 data 中的空白陣列
        const sheetDataRmBlank = workSheetsFromFile.reduce((acc, cur, idx) => {
          if (cur && Array.isArray(cur.data)) {
            acc[idx] = {};
            acc[idx].name = cur.name;
            acc[idx].data = cur.data.filter(
              (dt) => Array.isArray(dt) && dt.length > 0
            );
          }
          return acc;
        }, []);
        return Promise.resolve(sheetDataRmBlank);
      }
      return Promise.resolve(false);
    } catch (err) {
      return Promise.reject(err.message);
    }
  },
  // read excel file cols
  getExcelCols: (rows) => rows[0],
  // 比對檔案中的欄位是否與預設的欄位相同
  checkColsEqual: (cols, defaultCols) =>
    JSON.stringify(deepClone(cols).sort()) ===
    JSON.stringify(deepClone(defaultCols).sort()),
  // check 某個 col 的 value 是否符合設定
  // e.g. bestKnownName 必須是 @PER or @ORG
  validateSingleColVal: (mapList, key, checker) => {
    if (typeof checker !== "function") return true;
    return mapList.every((map) => {
      if (key in map) {
        return checker(map[key]);
      }
      return true;
    });
  },
  // 把 [["","",""],[],[],...] 轉變成 [{},{},...]
  arrayToMapList: (rows, headers) => {
    if (!(Array.isArray(rows) && Array.isArray(headers))) return [];
    return rows.reduce((acc, cur, idx) => {
      const curMap = headers.reduce((acc2, header, hIdx) => {
        // eslint-disable-next-line no-param-reassign
        acc2[header] = cur[hIdx];
        return acc2;
      }, {});
      acc.push(curMap);
      return acc;
    }, []);
  },
};

export default fileHelper;
